import { render } from "./OrderItemsComponent.vue?vue&type=template&id=40be8835&scoped=true&ts=true"
import script from "./OrderItemsComponent.vue?vue&type=script&lang=ts"
export * from "./OrderItemsComponent.vue?vue&type=script&lang=ts"

import "./OrderItemsComponent.vue?vue&type=style&index=0&id=40be8835&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40be8835"]])

export default __exports__